/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
  
  if (window.innerWidth > 740){
    $(".vss-video-arc-block").click(function(e){
        e.preventDefault();
        $(this).addClass('active');
        $(this).prevAll(".vss-video-arc-block").removeClass('active');
        $(this).nextAll(".vss-video-arc-block").removeClass('active');
    });
  }
  $(".vss-toggle").click(function(){
    $('.video-section-sidebar').toggleClass('active');
    $('.video-section-sidebar').find('span').toggle();
  });

  $('.pf-read-more').on('click', function () {
    var moreBlocks = $('.more-pf-fc-item');
    var isExpanded = moreBlocks.is(':visible');
    if (isExpanded) {
      moreBlocks.slideUp();
      $(this).text('Read more...');
    } else {
      moreBlocks.slideDown();
      $(this).text('Read less...');
    }
  });

  $('body').on('click','.addtocart-btn', function () {  
    var $this = $(this);
    var variantId = $this.attr('data-product-id');
    var cartDrawer = $('#sidebar-cart');
    console.log('variantId',variantId);
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: 1
      },
      dataType: 'json',
      success: function (data) {
        console.log('Product added to cart:', data);
        $('#sidebar-cart').attr('aria-hidden', 'false');
        $('.PageOverlay').addClass('is-visible');
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        
      },
      error: function (err) {
        console.error('Error adding to cart:', err);
      }
    });
  });

  $('body').on('click','.PageOverlay, .Drawer__Close', function () {
    $('.PageOverlay').removeClass('is-visible');
    $('#sidebar-cart').attr('aria-hidden', 'true');
  });

  var firstTitle = $(".faq-item-question").first();
  // firstTitle.addClass("active");
  // firstTitle.next(".faq-item-answer").slideDown();
  $('body').on('click','.faq-item-question', function(){
    var activeTitle = $(this);
    activeTitle.toggleClass('active');
    var currentDropdown = activeTitle.next('.faq-item-answer');
    $('.faq-item-question').not(activeTitle).removeClass('active');
    $('.faq-item-answer').not(currentDropdown).slideUp();
    currentDropdown.stop(true, true).slideToggle();
  });

  document.addEventListener("variant:changed", async function variantChanged(event) {
    let variant = event.detail.variant;
    let target = event.detail.customtarget;
    var product_handle = $(target).closest('.Product').attr("product-handle");
    if($(target).closest('form').find('.unique-blocks-design').length > 0 && $(target).closest('.ProductForm__Option').find('.unique-blocks-design').length == 0){
      $.ajax({
        type: 'GET',
        url: `/products/${product_handle}?variant=${variant.id}`,
        success: function(data) {
          $(target).closest('form').find('.unique-blocks-design').replaceWith($(data).find('.unique-blocks-design'));
        },
        error: function(error) {
          console.log("Error: "+ error);
        }
     });  
    }
    
  });
  
});


$(window).load( function() {
  
  setTimeout(function() {
    $('.ProductRecommendations').addClass('ProductRecommendationsss');
  }, 2000);
  var flickityHeight = $('.ProductRecommendations .flickity-viewport').outerHeight();
  var mainheight = flickityHeight;
  $('.flickity-viewport').css({
    'height' : mainheight
  });

  // var flickityHeightt = $('.ProductRecommendations .flickity-viewport').outerHeight();
  // var mainheightt = flickityHeightt;
  // $('.ProductRecommendations .flickity-viewport').css({
  //   'height' : mainheightt
  // });
  });